import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { EnvironmentService } from '../../services/environment/EnvironmentService';
import { PluginApiService } from '../../services/pluginapi/PluginApiService';
import { PluginListService } from '../../services/pluginlist/PluginListService';
import { formPluginUrl } from '../../utils/routes';
export function PluginOverlayContainer({ slotId, }) {
    const pluginApiService = PluginApiService.getNotificationInterface();
    const { myRole } = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const isMobile = EnvironmentService.getOutput().useIsMobile();
    const pluginOutputSlosts = PluginListService.getOutput().useSlots();
    const currentSlotPlugins = pluginOutputSlosts[slotId];
    // Create a stable map of ref callbacks to prevent unnecessary re-renders
    const iframeRefCallbacks = useMemo(() => {
        const callbacks = {};
        Object.keys(currentSlotPlugins).forEach((keyWithinSlot) => {
            callbacks[keyWithinSlot] = (iframe) => {
                if (iframe !== null) {
                    pluginApiService.notifyIframeMounted(slotId, keyWithinSlot, currentSlotPlugins[keyWithinSlot], iframe);
                }
            };
        });
        return callbacks;
    }, [pluginApiService, slotId, currentSlotPlugins]);
    return (_jsx(_Fragment, { children: Object.keys(currentSlotPlugins).map((keyWithinSlot) => {
            const plugin = currentSlotPlugins[keyWithinSlot];
            if (plugin.loadOnlyAtRole && plugin.loadOnlyAtRole !== myRole) {
                return null;
            }
            if (plugin.loadOnlyOnDeviceType &&
                plugin.loadOnlyOnDeviceType !==
                    (isMobile ? 'mobile' : 'desktop')) {
                return null;
            }
            return (_jsx(OverlayPluginIframe, { title: `${plugin.id} ${keyWithinSlot}`, src: formPluginUrl(plugin.pluginId, plugin.urlPath), ref: iframeRefCallbacks[keyWithinSlot] }, keyWithinSlot));
        }) }));
}
const OverlayPluginIframe = styled.iframe `
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 100%;
    background: transparent;
    opacity: 1;
    pointer-events: none;
`;
